import { Layout } from "antd";
import React from "react";
import LayoutOne from "../../layouts/LayoutOne";
import NewsInsightSlider from "../../wrappers/category/NewsInsightSlider copy";

const Blog = () => {
  return (
    <LayoutOne>
      <div className="container">
        <div className="row" style={{ borderRadius: "30px" }}>
          <div className="col-12" >
            <h2 className="mb-4">News</h2>
          </div>
        </div>

        {/* Featured News */}
        <div className="row mb-5 w-100" style={{ overflow: 'hidden', boxShadow: '0 4px 10px rgba(0,0,0,0.1)', padding: "30px 30px 30px 30px", }}>
          {/* Left Text Content */}
          <div
            className="col-md-6 d-flex flex-column justify-content-center"
            style={{ backgroundColor: '#0b3d91', color: 'white', padding: '30px', borderTopLeftRadius: "10px", borderBottomLeftRadius: "10px" }}
          >
            <div style={{ marginBottom: '10px' }}>
              <button style={{
                backgroundColor: 'white',
                color: '#0b3d91',
                border: 'none',
                padding: '5px 15px',
                fontWeight: '600'
              }}>
                News
              </button>
            </div>
            <span style={{ fontSize: '0.9rem', marginBottom: '15px' }}>22 Jan, 2024</span>
            <h4 style={{ fontWeight: '600', marginBottom: '15px', color: "white" }}>
              Lorem Ipsum is Simply Dummy Text Of The Printing And Typesetting Industry.
            </h4>
            <p style={{ fontSize: '0.9rem', marginBottom: '20px', color: "white" }}>
              Lorem Ipsum is simply dummy text of the printing and typesetting industry.
              Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
              when an unknown printer took a galley of type and scrambled it to make a type
              specimen book. It has survived not only five centuries, but also the leap into
              electronic typesetting, remaining essentially unchanged.
            </p>
            <a href="#" className="fw-bold" style={{ color: '#ffffff', textDecoration: 'underline' }}>
              Read More...
            </a>
          </div>

          {/* Right Image */}
          <div className="col-md-6 p-0" >
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ6fqeky0NSm0kTwgOyAY7FtbCMAgb0ym1CGA&s"
              alt="Featured News"
              style={{ width: '100%', height: '100%', objectFit: 'cover', borderTopRightRadius: "10px", borderBottomRightRadius: "10px" }}
            />
          </div>
        </div>

        {/* View All link */}
        <div className="row mb-4">
          <div className="col-12 text-end">
            <a href="#" className="text-decoration-none fw-bold">View All News Insight Mobile Repair</a>
          </div>
        </div>

        <NewsInsightSlider />



      </div >
    </LayoutOne >
  );
};

export default Blog;